<div class="container-card" [class.list-card]="list"
    (mousedown)="$event.button === 1 && openInNewTab($event, card)">
    <div class="etiqueta-event pill-state pointer-in" *ngIf="tag" (click)="goToPage(card)" [ngClass]="tag.class">
        <i class="fal {{ tag.icon }}"></i> {{ tag.text }}
    </div>
    <div class="container-img pointer-in" (click)="goToPage(card)">
        <img (error)="imageUrl = '../../../../assets/img/image_default.png'" class="img-card-event" [src]="imageUrl" />
        <div class="sold-out-overlay" *ngIf="isSoldOut">
            <p class="sold-out-title">Entradas agotadas</p>
            <p class="sold-out-subtitle">¡Nos vemos en el próximo!</p>
        </div>
        <!-- El mismo reloj de la ficha del evento, sobre el cartel atenuado.
             Con más de un día por delante los segundos son ruido; por debajo
             son lo que engancha, así que la unidad más pequeña entra sola -->
        <div class="soon-overlay" *ngIf="!list && isUpcoming && countdown as cd">
            <div class="soon-clock">
                <div class="clock-cell" *ngIf="cd.showDays">
                    <span class="clock-box">{{ cd.dd }}</span>
                    <span class="clock-tag">{{ cd.days === 1 ? 'Día' : 'Días' }}</span>
                </div>
                <div class="clock-cell" *ngIf="cd.showHours">
                    <span class="clock-box">{{ cd.hh }}</span>
                    <span class="clock-tag">Horas</span>
                </div>
                <div class="clock-cell" *ngIf="cd.showMinutes">
                    <span class="clock-box">{{ cd.mm }}</span>
                    <span class="clock-tag">Min</span>
                </div>
                <div class="clock-cell" *ngIf="cd.showSeconds">
                    <span class="clock-box">{{ cd.ss }}</span>
                    <span class="clock-tag">Seg</span>
                </div>
            </div>
        </div>
    </div>
    <div class="info-card">
        <div class="d-flex w-100 align-items-center">
            <i class="fa-heart icon-card pointer-in" *ngIf="!totemActive && user"
                [class]="isWishlist ? 'fas icon-primary' : 'fal'" (click)="editFavorito()"></i>
            <i class="fal fa-share-alt pointer-in" *ngIf="sharedSupported && !totemActive" (click)="shareEvent()"></i>
            <span
                *ngIf="displayFromPrice == 0 && !card.image_url?.includes('http') && !card.external && !card.informative"
                class="price-free">GRATUITO</span>
            <span
                *ngIf="displayFromPrice == null || ((card.external && card.image_url.includes('http')) || (card.external && !displayFromPrice) || card.informative)"
                class="price-free">+INFO</span>
            <span *ngIf="displayFromPrice > 0 && !card.image_url?.includes('http') && !card.informative"
                class="justify-self-end price-event">Desde <span class="price-free">{{ displayFromPrice | number: '1.0-2' }}
                    €</span></span>
        </div>
        <p class="text-info-event pointer-in" [title]="card.title" (click)="goToPage(card)">{{ card.title }}</p>
        <div class="card-meta">
            <div class="date-event city-event pointer-in" *ngIf="cityName" (click)="goToPage(card)">
                <i class="fa-light fa-location-dot"></i>
                <span>{{ cityName }}</span>
            </div>
            <div class="date-event pointer-in" (click)="goToPage(card)"
                *ngIf="(!card.end_date || (card.end_date | date: 'dd MMM':'+0000') == (card.nextSession?.start_date | date: 'dd MMM':'+0000')); else divRange">
                <i class="fa-light fa-calendar"></i>
                <span>{{ (card.nextSession?.start_date | date: 'dd MMM':'+0000') == (today | date: 'dd MMM':'+0000') ? 'Hoy' :
                    (card.nextSession?.start_date | date: 'EEE dd MMM':'+0000' | titlecase) }}</span>
                <span *ngIf="card.nextSession != null">|</span>
                <span *ngIf="card.nextSession">{{ card.nextSession?.start_date | date: 'HH:mm':'+0000' }}</span>
            </div>
            <ng-template #divRange>
                <div class="date-event pointer-in" (click)="goToPage(card)"
                    *ngIf="card.end_date && ((card.end_date | date: 'dd MMM':'+0000') != (card.nextSession?.start_date| date: 'dd MMM':'+0000')); else divSingle">
                    <i class="fa-light fa-calendar"></i>
                    <span>{{ (card.nextSession?.start_date | date: 'EEE dd MMM':'+0000' | titlecase) }}</span>
                    <span>-</span>
                    <span>{{ (card.end_date | date: 'EEE dd MMM':'+0000' | titlecase) }}</span>
                </div>
                <ng-template #divSingle>
                    <div class="date-event pointer-in" (click)="goToPage(card)">
                        <i class="fa-light fa-calendar"></i>
                        <span>{{ (card.nextSession?.start_date | date: 'EEE dd MMM':'+0000' | titlecase) }}</span>
                        <span>{{ (card.nextSession?.start_date | date: 'HH:mm':'+0000') }}</span>
                    </div>
                </ng-template>
            </ng-template>
        </div>
    </div>
</div>